import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MotionDiv, useTitle } from "../../components";
import ViewContent from "./ViewContent";
import DeleteContent from "./DeleteContent";

const TACA = "TERMS_AND_CONDITIONS_APPRAISER";
const TACL = "TERMS_AND_CONDITIONS_LENDER";
const PPA = "PRIVACY_POLICY_APPRAISER";
const PPL = "PRIVACY_POLICY_LENDER";


export default function Content() {
  const navigate = useNavigate();
  const [Id, setId] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const deleteHandler = (id) => {
    setId(id);
    setShowConfirmationModal(true);
  };

  // console.log(".......content", content);
  useTitle("Content");
  return (
    <MotionDiv>
      <h4>Appraiser</h4>
      <ViewContent
        type={TACA}
        url="/admin/content/create?TYPE=TACA"
        text="Terms & Conditions"
        onEdit={() => navigate("/admin/content/update?TYPE=TACA")}
        onDelete={() => deleteHandler(TACA)}
      />
      <br />
      <ViewContent
        type={PPA}
        url="/admin/content/create?TYPE=PPA"
        text="Privacy Policy"
        onEdit={() => navigate("/admin/content/update?TYPE=PPA")}
        onDelete={() => deleteHandler(PPA)}
      />
      <br />
      <h4>Lender</h4>
      <ViewContent
        type={TACL}
        url="/admin/content/create?TYPE=TACL"
        text="Terms & Conditions"
        onEdit={() => navigate("/admin/content/update?TYPE=TACL")}
        onDelete={() => deleteHandler(TACL)}
      />
      <br />
      <ViewContent
        type={PPL}
        url="/admin/content/create?TYPE=PPL"
        text="Privacy Policy"
        onEdit={() => navigate("/admin/content/update?TYPE=PPL")}
        onDelete={() => deleteHandler(PPL)}
      />
      <br />
      {/* <DeleteContent
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        id={Id}
      /> */}
    </MotionDiv>
  );
}
